import _ from 'lodash';

export const DISABLED_MESSAGES = 'disabled_messages';

export const getDisabledMessages = () => {
  const messages = window.localStorage.getItem(DISABLED_MESSAGES);
  return messages ? JSON.parse(messages) : [];
};

export const setDisabledMessages = (id) =>
  window.localStorage.setItem(DISABLED_MESSAGES, JSON.stringify(_.castArray(id)));

export const addDisabledMessages = (id) => {
  setDisabledMessages(_.uniq([...getDisabledMessages(), ..._.castArray(id)]));
};

export const isDisabledMessage = (id) => getDisabledMessages().includes(id);

export const clearUnusedDisabledMessages = (id) => {
  setDisabledMessages(_.intersection(getDisabledMessages(), _.castArray(id)));
};
